import { OfficeBuildingCogIcon } from './OfficeBuildingCogIcon';

/**
 * author: Joshua Solomon
 * id 4A51F91C-857B-454A-8753-7AACF3B085A9
 * name office-building-cog
 * version: 6.4.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/office-building-cog.svg
 * tags
 * - Settings 
 * - Places 
 */
export const OfficeBuildingSettingsIcon = OfficeBuildingCogIcon;
export default OfficeBuildingSettingsIcon